module.exports = __webpack_public_path__ + "static/media/illu_missions.5999b936.svg";